export const styles = `
.component-Elements-Tag {
 background-color: #dfe5f2;
 color: #353535;
 border: 1px solid #b5bdd5;
 border-radius: 6px;
 padding: 5px 15px;
 text-align: center;
 margin-bottom: 10px;
 margin-right: 15px;
 font-size: 12px;
 display: inline-flex;
 align-items: center;
 word-break: break-word;
 word-wrap: break-word;
}
 .component-Elements-Tag.pinkTag {
 background-color: #fbf2f5;
}
 .component-Elements-Tag span.component-Icons-SVGIconWrapper {
 display: inline-block;
 margin-left: 3px;
 height: 13px;
 width: 13px;
 word-break: break-word;
 word-wrap: break-word;
}
 .component-Elements-Tag span.component-Icons-SVGIconWrapper svg {
 height: 13px;
 width: 13px;
}
 .component-Elements-Tag .cancel-image-box {
 fill: #dfe5f2;
}
 `;
